import { Injectable, Input } from '@angular/core';
import { IDashboardSection } from '../dashboard.component';
import { IDashboardMetadata } from '../dashboard-metadata.service';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';

@Injectable()
export abstract class BaseDashboardFooterComponent {
  @Input() public dashboardMetadata:IDashboardMetadata;
  @Input() public filters:IObject;
  @Input() public sections:IDashboardSection[];
  @Input() public dashboardCode:string;
  @Input() public companyCountryId:string;
  @Input() public countryId:number;
  @Input() public loading:boolean;

  protected getSectionRowCount(sectionCode:string):number|string {
    const section:IDashboardSection = _.find(this.sections, (section) => section.code === sectionCode);
    return section?.report?.indicator;
  }
}